import React, { useState } from "react";
import { Container, FormControl, Grid, InputLabel, MenuItem, Select, Typography } from "@material-ui/core";
import PageBreadcrumbs from "../components/Breadcrumbs/PageBreadcrumbs";
import { breadcrumbNode } from "../components/Breadcrumbs/PageBreadcrumbs.d";
import Button from "jb_component_library/components/Button";
import { useGetCriterias } from "../api/replenishmentApi";
import InventoryDataGrid from "../components/InventoryDataGrid/InventoryDataGrid";
import MultiSelect from "../components/MultiSelect/MultiSelect";
import useInitialAppData from "../Hook/UseInitialAppData";
import { location } from "../api/Models/location";
import { inventorySearchValues } from "../api/Models/inventorySearchValues";



const Inventory: React.FC = () => {
	const breadcrumbNodes: breadcrumbNode[] = [{ name: "Review Min / Max" }];
	const { locations: allLocations } = useInitialAppData();
	const [{ data: criterias }] = useGetCriterias();
	const [formValues, setFormValues] = useState<{criteriaId: string, locations: Array<location>}>({criteriaId: "", locations: []});
	const selectedLocations = formValues.locations.map(m => {
		const loc = allLocations.find(l => l.id.toString() === m.id.toString());
		return({id: m.id, name: loc?.name});
	});
	const [inventorySearchValues, setInventorySearchValues] = useState<inventorySearchValues>();

	const onSearch = async () => {
		const locationIds = selectedLocations.map(m => m.id.toString());
		const criteriaId = formValues.criteriaId;
		setInventorySearchValues({criteriaId, locationIds});
	}

	const handleInputChange = (e) => {
		const { name, value } = e.target;
		setFormValues({
			...formValues,
			[name]: value,
		});
	};

	const handleLocationChange = (e) => {
		const { locations } = formValues;
		const { name, checked } = e.target;
		const updatedLocations = locations.filter(m => m.id.toString() !== name);
		if(checked) {
			updatedLocations.push({ id: name });
		}
		setFormValues({
			...formValues,
			locations: updatedLocations,
		});
	}



	return (
		<Container maxWidth={false}>
			<Grid container spacing={6}>
				<Grid container item direction="row">
					<Grid item xs={12} sm={8}>
						<PageBreadcrumbs nodes={breadcrumbNodes} />
					</Grid>
				</Grid>
				<Grid container>
					<Typography>Review inventory and min/maxes</Typography>
				</Grid>
				<Grid item container direction="column" xs={6} md={6} spacing={4}>
					<Typography variant="h3">Criteria</Typography>
					<FormControl fullWidth variant="outlined">
						<InputLabel id="select-criteria-label">Criteria</InputLabel>
						<Select
							id="select-criteria"
							name="criteriaId"
							labelId="select-criteria-label"
							label="Criteria"
							value={formValues.criteriaId}
							onChange={handleInputChange}
							variant="outlined"
						>
							{criterias?.map(m => {
								return (<MenuItem key={m.id} value={m.id}>{m.name}</MenuItem>)
							})}
						</Select>
					</FormControl>
					<Grid item xs={2}>
						<Button type="primary" onClick={onSearch}>Search</Button>
					</Grid>
				</Grid>
				<Grid item container direction="column" xs={6} md={6} spacing={4}>
					<Typography variant="h3">Locations</Typography>
						<MultiSelect
							title="Locations"
							options={allLocations}
							values={selectedLocations}
							onSelectionChange={handleLocationChange}
						/>
				</Grid>
				<Grid item xs={12}>
					{inventorySearchValues && <InventoryDataGrid inventorySearchValues={inventorySearchValues}/>}
				</Grid>
			
			</Grid>
		</Container>
	);
};

export default Inventory;
